import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from 'react-router-dom'//React routes
import { Typography, IconButton, Box, Button, styled, useTheme } from '@mui/material';
import { LocationOnRounded as LocOnRounded } from "@mui/icons-material"
import CloseIcon from "@mui/icons-material/Close";
import { BottomSheet } from "react-spring-bottom-sheet"
import "react-spring-bottom-sheet/dist/style.css"
import { useForm, FormProvider, } from "react-hook-form";

import "./bottomSheetStyle.css"
//import { mainStyles, theme } from "../../styles/Main.js"
import { workflowActions, fileActions, addTitleLegoCurrent } from "../../store/actions"
import { useStyles } from "./PolicyStyles"
import { CustomLoadingOverlay, InputField, LocationDialogComponent, Buttons, GenericContainer, GenericContainerForm, GeoLocationGeneric } from "../../components"
import { getChecksStage, b64toUrl, coreFunctions } from '../../utils'
import VisorPDF from "../../components/Visor/VisorPDF.js";
import { useTranslation } from 'react-i18next';

const LocationOnRounded = styled(LocOnRounded)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main40,
  color: '#FFFFFF',
  height: '35px',
  width: '35px',
  borderRadius: '100%',
  marginLeft: '8px',
  marginTop: '3px',
  padding: '6px',
}));

export default function PolicyComponent(props) {
  const theme = useTheme()
  const location = useLocation()

  const formMethods = useForm();
  const { control, handleSubmit, watch, formState, reset, setValue } = useForm({ mode: 'onBlur' });

  const [fileId, setFileId] = useState(false)
  const [activeFileChkAcceptance, setActiveFileChkAcceptance] = useState(false)
  const [activeFileChkConfirm, setActiveFileChkConfirm] = useState(false)
  const [activeButton, setActiveButton] = useState(false)
  const [activeLocation, setActiveLocation] = useState(false)
  const [titleProp, setTitleProp] = useState("")
  const [instTextProp, setInstTextProp] = useState("")
  const [activeGeolocation, setActiveGeolocation] = useState(false)

  const [openLocation, setOpenLocation] = useState(false)

  const [response, setResponse] = useState("")
  const [loadView, setLoadView] = useState(true)
  const [stageProperties, setStageProperties] = useState([])
  const [listChecks, setListChecks] = useState([])
  const [title, setTitle] = useState("")
  const [panelVisible, setPanelVisible] = useState(false)
  const [latitude, setLatitude] = useState("-85.05112878")
  const [longitude, setLongitude] = useState("-180")
  const localStyles = useStyles() //estílos de este componente (PolicyStyles.js)
  const navigate = useNavigate()//Módulo "History" de react router 
  const [containerHeight, setContainerHeight] = useState(80);
  const { t } = useTranslation();

  const watchedConsentimientoValue = watch("Doy_consentimiento_para_que_durante_el_proceso_s");

  //Redux hooks
  const fileChkConfirm = useSelector((state) => state.FileCheck)
  const fileChkAcceptance = useSelector((state) => state.FileCheckAcceptance)
  const file = useSelector(state => state.FileInfo)
  const dispatch = useDispatch();

  useEffect(() => {
    if (watchedConsentimientoValue == true) {
      setActiveLocation(true)
    } else if (watchedConsentimientoValue == undefined || watchedConsentimientoValue == false) {
      setActiveLocation(false)
    }
  }, [watchedConsentimientoValue]);


  useEffect(() => {
    setFileId(location.state.folioId)
    dispatch(fileActions.GetFileInfo(location.state.folioId));
    dispatch(fileActions.CheckDeAceptacionPDF({ Folio: location.state.folioId }))
    setActiveFileChkAcceptance(true)
    handleResize()
  }, []);

  useEffect(() => {
    dispatch(addTitleLegoCurrent(t("privacy_notice")))
    // Agregar el event listener en el montaje del componente
    window.addEventListener('resize', handleResize);

    // Limpiar el event listener en el desmontaje del componente
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // El segundo parámetro del useEffect es un arreglo vacío para ejecutarlo solo una vez al montar/desmontar el componente

  useEffect(() => {
    setLoadView(file.loading)
    //Se cachan parámetros de salida en UI desde persistencia de datos, nombre, correo y teléfono
    if (file.items != undefined) {
      loadInformationStage(file.items)
    }
  }, [file])

  useEffect(() => {
    if (stageProperties.length > 0) {
      // console.log("stageProperties: ", stageProperties)
      let pdfName = stageProperties.find(item => item.Name == "PDFResourceName")?.Value
      dispatch(workflowActions.GetResourceData(pdfName));
    }
  }, [stageProperties]);

  useEffect(() => {
    setLoadView(fileChkAcceptance.loading)
    if (fileChkAcceptance.items != undefined && activeFileChkAcceptance) {
      setTitle(fileChkAcceptance.items.Title)
      configurePdf();
    } else if (fileChkAcceptance.error != undefined && activeFileChkAcceptance) {
      setLoadView(false)
      alert(fileChkAcceptance.error)
    }
  }, [fileChkAcceptance]);

  useEffect(() => {
    //Validar que la información haya sido recibida correctamente por el API
    setLoadView(fileChkConfirm.loading);
    if (fileChkConfirm.error != undefined && activeFileChkConfirm) {
      alert(fileChkConfirm.error);
      setLoadView(false)
    } else {
      if (fileChkConfirm.items != undefined && activeFileChkConfirm) {
        if (fileChkConfirm.items?.Stage?.Name == "Check de aceptación") {
          setListChecks([])
          setPanelVisible(false)
          setActiveLocation(false)
          dispatch(fileActions.CheckDeAceptacionPDF({ Folio: fileId }))
          loadInformationStage(fileChkConfirm.items)
        } else {
          let nextStage = fileChkConfirm.items.Stage
          let stageName = nextStage.Name
          let stageId = nextStage.Id
          let folioId = fileId
          let stage = fileChkConfirm.items

          let nextComponent = coreFunctions.GetLegoNext(stageName)
          console.log("Net Lego Stage********************: ", nextComponent, stageName, stageId, stage, folioId)
          coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
        }
      }
    }
  }, [fileChkConfirm]);

  // useEffect(() => {
  //   // let filterChecks = listChecks.filter(item => item.Value != null)
  //   // console.log("filterChecks***********: ", filterChecks)
  //   listChecks.forEach((itemCheck) => {
  //     console.log("itemCheck***********: ", itemCheck)
  //     setValue(itemCheck.Name, itemCheck.Value)
  //   });
  // }, [listChecks]);

  const handleResize = () => {
    const windowHeight = window.innerHeight;
    const newHeight = windowHeight > 900 ? 75 : 70
    console.log("............newHeight.......handleResize............", windowHeight, newHeight)
    setContainerHeight(newHeight)
  };

  let configurePdf = async () => {
    let pdfb64 = fileChkAcceptance.items.PDF;
    const blobUrl = await b64toUrl(`data:application/pdf;base64,${pdfb64}`);
    // const blobUrl = URL.createObjectURL(blob);
    console.log("blobUrl: ", blobUrl)
    setResponse(<VisorPDF pdfUrl={blobUrl} porcentaje={containerHeight} />)
  };

  let handleSendInfo = (data) => {
    console.log("Data: ", data)
    let dateTime = coreFunctions.getActualDateTime()
    let checkedList = listChecks.map((item) => {
      return {
        TextCheck: item.Label,
        Accepted: data[item.Name]
      }
    })

    let dateArray = dateTime.split("|")
    let date = dateArray[0]
    let time = dateArray[1]
    let splittedDate = date.split("-")
    let year = splittedDate[0]
    let month = splittedDate[1]
    let day = splittedDate[3]
    let folio = fileId;

    let objRequest = {
      Folio: folio, //FileId
      Confirmations: checkedList, //Array
      TimeStamp: date + " " + time, //Fecha actual en formato: '2021-02-08 14:34:22'
      Latitude: `${latitude}`, //Latitud actual
      Longitude: `${longitude}`, //Longitud actual
      TrackingData: { IMEI: "FC:01:7C:45:48:3F", Reference: "" }, //Información del dispositivo (No aplica)
      // TextAudioEvidence:
      //   "Doy mi consentimiento para el proceso de grabación de mi imagen, manifiesto que estoy actuando por cuenta propia y acepto el tratamiento de mis datos personales, para finalidades especificas.", //String con mensaje de audio
      // TextVideoEvidence: `Siendo las <b>${time} del día ${day} de ${month} del ${year}</b>, autorizo el uso de mi firma digital autógrafa para registrarla en la documentación generada automática`, //String con mensaje de video
    };

    console.log("objRequest", objRequest)
    dispatch(fileActions.CheckAcceptanceConfirm(objRequest)); //Almacenar información en backend mediante API
    setActiveFileChkConfirm(true)
    reset()
  };

  let handlePanelChecks = () => {
    setPanelVisible((panelVisible) => !panelVisible)
    //  setActiveLocation(false)
  };

  let closePanelChecks = () => {
    setPanelVisible((panelVisible) => !panelVisible)
  }

  let OpenDialogLocation = () => {
    // console.log("---- OPEn LOCATION ----", props)
    setPanelVisible(false)
    setOpenLocation(true)
  }

  let CloseDialogLocation = () => {
    // console.log("Cerrar modal geolocalizacion-------------")
    setOpenLocation(false)
    setPanelVisible(true)
  }

  let loadInformationStage = (items) => {
    // console.log("file.items: ", file.items)
    let instText = items.Stage.Properties.find(item => item.Name == "InstructionText")?.Value
    let title = items.Stage.Properties.find(item => item.Name == "Title")?.Value
    let actGeoloc = items.Stage.Properties.find(item => item.Name == "ActiveGeolocation")?.Value
    dispatch(addTitleLegoCurrent(title))
    // setTitleProp(title)
    setInstTextProp(instText)
    console.log("actGeoloc-----PARAM--- CONFIG---- ", actGeoloc)
    setActiveGeolocation(actGeoloc)
    // InstructionText, Title
    let listElements = getChecksStage(items.Stage)
    if (location.state.checkList?.length > 0) {
      console.log("Entro: ", location.state.checkList)
      setListChecks(location.state.checkList)
    } else {
      // console.log("Entro: listElements: ", listElements)
      setListChecks(listElements)
    }
  }

  const resetValues =()=>{
    listChecks.forEach((itemCheck) => {
      console.log("itemCheck***********: ", itemCheck)
      setValue(itemCheck.Name, false)
    });
  }

  console.log('listChecks', listChecks)

  return (<GenericContainer>
    <FormProvider {...formMethods} >
      {activeGeolocation &&
        <GeoLocationGeneric SuccessFN={(latitude, longitude) => {
          console.log("succes,latitude, longitude ", latitude, longitude);
          setLatitude(latitude);
          setLongitude(longitude);
        }}
          ErrorFN={(error) => console.log('error', error)}
        />
      }
      {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}

      <LocationDialogComponent open={openLocation} closeAction={CloseDialogLocation} />
      {/* <Typography variant="h6" gutterBottom >{titleProp}</Typography> */}
      <Typography variant="subtitle" gutterBottom >{instTextProp}</Typography>

      <GenericContainerForm dynamicSize={window.innerHeight > 900 ? 300 : 350}>
        {fileChkAcceptance.loading ? ''
          : response
        }
      </GenericContainerForm>
      <BottomSheet style={{
        margin: '0 !important',
        padding: '0 !important',
        zIndex: 90
      }}
        open={panelVisible}
        header={
          <Box sx={{
            backgroundColor: theme.palette.primary.main,
            borderTopRightRadius: '10px',
            borderTopLeftRadius: '10px',
            display: 'flex',
            flexDirection: "row",
          }} >
            <Box sx={{ width: "50px" }}>
              {activeLocation &&
                <LocationOnRounded onClick={OpenDialogLocation} />
              }
            </Box>
            <Box sx={{ width: "100%" }}>
              <Button sx={{
                backgrounColor: theme.palette.primary.main,
                color: "#FFFFFF",
                boder: `1px solid #${theme.palette.primary.main}`,
                outline: 'none !important',
              }}
                onClick={handlePanelChecks}
              >
                {t("privacy_auth")}
              </Button>
            </Box>
            <Box sx={{ width: "50px" }}>
              <IconButton
                className={localStyles.backButton}
                onClick={closePanelChecks}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        }
      >
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'left',
          margin: '14px !important'
        }}>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'left',
          }}>
            {listChecks.map((itemInput) => {
              return <InputField
                inputType="check"
                control={control}
                name={`${itemInput.Name}`}
                label={itemInput.Label}
                required={itemInput.Required}
                validations={{ required: itemInput.Required }}
                error={!!formState.errors[`${itemInput.Name}`]}
                helperText={formState.errors[`${itemInput.Name}`]?.message}
                // defaultValue={itemInput.Value}
                onSelect={(e) => {
                  console.log("...........e.target.checked........: ", e.target.checked)
                  let original = listChecks
                  var listCheckFind = original.filter(item => item.Group != undefined && item.Group != "" && item.Group == itemInput.Group)
                  console.log("...........listCheckFind........: ", listCheckFind)
                  let updateChecks = original.map(itemCheck =>
                    itemCheck.Name.toUpperCase() === itemInput.Name.toUpperCase() && itemCheck.Group != undefined
                      ? {
                        ...itemCheck,
                        Value: e.target.checked
                      }
                      : itemCheck.Name.toUpperCase() === itemInput.Name.toUpperCase() && itemCheck.Group == itemInput.Group
                        ? {
                          ...itemCheck,
                          Value: e.target.checked
                        }
                        : {
                          ...itemCheck,
                          Value: itemCheck.Group == undefined || itemInput.Group == undefined ? itemCheck.Value : false
                        }
                  )
                  console.log("updateChecks: ", updateChecks)
                  setListChecks(updateChecks)
                }}
              />
            })}
          </Box>

          <Typography variant="subtitle1" gutterBottom sx={{ marginTop: "0.5em" }} >
            {t("privacy_message")}
          </Typography>

          <Buttons
            ConfirmButtonText={t("general_accept")}
            onClickConfirm={handleSubmit(handleSendInfo)}
            disabled={activeButton ? false : true}
            onClickCancel={() => {
              handlePanelChecks()
              resetValues();
              // reset()
            }}
            CancelButtonText={t("general_cancel")}
          />
        </Box>
      </BottomSheet>
      {panelVisible == false ?
        <Buttons marginTop={2} ConfirmButtonText={t("privacy_auth")}
          onClickConfirm={handlePanelChecks} /> : null}
    </FormProvider>
  </GenericContainer>);
}
